<template>
  <div>
    <div
      v-for="(module, index) in modules"
      :key="module.id || index"
      @click="navigateToModule(module.id)"
      :class="[
        'tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border-l-8 tw-p-6 tw-transition-all tw-duration-300 tw-border-blue-100 hover:tw-shadow-md tw-cursor-pointer module-item tw-mb-3',
        module.status === '1'
          ? 'tw-border-green-200'
          : module.status === '0'
          ? 'tw-border-blue-200'
          : 'tw-border-yellow-200',
      ]"
    >
      <!-- STATUS BADGE -->
      <span
        v-if="moduleIsCompleted(module)"
        class="tw-bg-green-100 tw-text-green-700 tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold"
      >
        Completed
      </span>
      <span
        v-else
        class="tw-bg-blue-100 tw-text-blue-700 tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold"
      >
        Not started
      </span>

      <div class="tw-flex sm:tw-flex-row tw-flex-wrap tw-items-center">
        <div class="tw-flex tw-flex-col">
          <h2 class="tw-text-2xl tw-text-gray-800 tw-my-1 font-title">
            {{ module.goal }}
          </h2>
        </div>
        <div class="tw-flex tw-items-center sm:tw-ml-auto">
          <BaseButton class="" text="View Module" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelfMentorshipModules",
  props: {
    modules: {
      type: Array,
      required: true,
    },
  },
  methods: {
    navigateToModule(moduleId) {
      if (!moduleId) return;

      const selectedModule = this.modules.find((m) => m.id === moduleId);
      if (!selectedModule) return;

      // Navigate to the module details page
      this.$router.push({ name: "module", params: { id: moduleId } });
    },

    moduleIsCompleted(module) {
      return !!module.completed;
    },
  },
};
</script>

<style scoped>
.module-item:hover {
  transform: translateY(-2px);
}
</style>
